const retryFetch = require("../../utils/retry-fetch");
const path = require("../../utils/path");

/**
 * Purchase function
 * @param {Object} sessionContext
 * @param {Array} items { productNumber, productType, quantity }
 */
const purchase = (sessionContext, items) => {
  
  return getBagsForUser(sessionContext.userId)
    .then((bagId) =>
    
      addToBag({
        bagId,
        sessionContext,
        items,
      })
    )
    .then((unverifiedBagId) => {
      return handleMissingBagId(unverifiedBagId, sessionContext.userId);
    })
    .then((bagId) => getBagContent(sessionContext.userId, bagId))
    .then((itemQty) => ({
      itemQty,
      status: "CART_ADD_SUCCESS",
    }))
    .catch((error) => ({ status: "CART_ADD_FAIL", error, sessionContext }));
};

// Emergency fix function to make China ecom go live
const handleMissingBagId = (unverifiedBagId, userId) =>
  unverifiedBagId ||
  waitForSeconds(2)()
    .then(() => getBagsForUser(userId))
    .then(
      (mostProbablyABagId) =>
        mostProbablyABagId ||
        Promise.reject(
          new Error("Was not able to get bag ID after several attempts!")
        )
    );

const securemaBaseUrl = CONFIG.securemaBaseUrl;
const market = CONFIG.iowsLocale;
const language = CONFIG.language;
const getBagsForUser = (userId) => {
  // notify.getCarts(PIP_API_INITIATE);
  if (!userId) return Promise.reject("User ID is missing.");
  const requestObject = getRequestObject.getBags({ userId });
  return retryFetch(3, 1000)(requestObject.url, requestObject).then(
    (response) => {
      // notify.getCarts(PIP_API_SUCCESS);
     
      return  path(response.length?response[0]:response)(
        "bagId",
      );
    }
  );
};

const postShoppingBag = (state) => {
  const productPostDataPayload = postPayload({
    userId: state.sessionContext.userId,
    items: state.items,
  });

  const requestObject = getRequestObject.post({
    userId: state.sessionContext.userId,
    payload: productPostDataPayload,
  });
  // notify.postCart(PIP_API_INITIATE);
  return retryFetch(3, 1000)(requestObject.url,requestObject).then((res) => {
    // const possibleError = path(res?.errorList[0])("errorMessage");
    let possibleErrorCode 
    let  bagId
    if(res && res.hasOwnProperty('errorList')){

        possibleErrorCode = path(res?.errorList[0])("errorCode");
    }else{
        bagId = path(res)("bagId");
    }
    
    if (possibleErrorCode === 50101) {
      // notify.exception(PIP_API_EXCEPTION_CART_COLLISION);
      return Promise.reject({
        shouldHandleAsExistingCart: true,
        response: res,
        request: requestObject,
      });
    } else if (possibleErrorCode) {
      // notify.exception(PIP_API_EXCEPTION_CART_OTHER);
      return Promise.reject(new Error(`error code: ${possibleErrorCode}`));
    }
    // notify.postCart(PIP_API_SUCCESS);
    return bagId;
  });
};

const putShoppingBag = (state) => {
  const productPutDataPayload = putPayload(state);

  const requestObject = getRequestObject.put({
    bagId: state.bagId,
    userId: state.sessionContext.userId,
    payload: productPutDataPayload,
  });
  // notify.putCart(PIP_API_INITIATE);
  return retryFetch(
    3,
    1000,
    true
  )(requestObject.url,requestObject).then((res) => {
    if(res && Object.keys(res).length){
      const possibleError = path(res?.errorList[0])("errorMessage");
      if (possibleError) {
        // notify.exception(PIP_API_EXCEPTION_CART_OTHER);
        return Promise.reject(new Error(`error code: ${possibleError}`));
      }
    }
   
    // notify.putCart(PIP_API_SUCCESS);
    return state.bagId;
  });
};

const getBagContent = (userId, bagId) => {
  if (!bagId) return Promise.reject("Bag ID is missing.");
  console.log('====================================');
  console.log("userId", userId);
  console.log('====================================');
  
  const requestObject = getRequestObject.getBag({ userId, bagId });
  // notify.getCart(PIP_API_INITIATE);
  return retryFetch(3, 1000)(requestObject.url, requestObject).then(
    (response) => {
      // notify.getCart(PIP_API_SUCCESS);
      const itemList = path(response?response.shoppingBagSectionList[0]:response)(
         "shoppingBagItemList",
      );
      if (!itemList && !itemList.length) {
        return Promise.reject({
          message: "No item in the shopping bag.",
          bagId,
          userId,
        });
      }
      return Array.isArray(itemList)
        ? itemList.reduce(
            (itemCount, currentItem) => itemCount + currentItem.itemQty,
            0
          )
        : itemList.itemQty;
    }
  );
};

const waitForSeconds = (timeout) => (toResolve) =>
  new Promise((res) => {
    setTimeout(() => {
      return res(toResolve);
    }, timeout * 1000);
  });

const addToBag = (state) => {
  
  return state.bagId
    ? putShoppingBag(state)
    : postShoppingBag(state).catch((err) => {
        if (err.shouldHandleAsExistingCart) {
          // If cart already exists despite earlier check
          // (This case sometimes happens in China.)
          return getBagsForUser(state.sessionContext.userId).then((bagId) => {
            if (!bagId) {
              return Promise.reject(
                "Could not get bag ID for user even after waiting and retrying!"
              );
            }
            return putShoppingBag(Object.assign({}, state, { bagId }));
          });
        }
        return Promise.reject(err);
      });
};

/**
 * Payload for POST requests
 * @param {Array} items { productNumber, productType, quantity }
 */
const postPayload = (payload) => {
  return {
    BagType: "ONLINESHOPPINGCART",
    BagSource: "M2",
    BagName: "CART",
    CustomerSource: "M2",
    CustomerId: payload.userId,
    CreatedDateTime: new Date().toUTCString(),
      shoppingBagSectionList: [
        {
          shoppingBagItemList: payload.items.map((item) => ({
            itemType: item.productType.toUpperCase(),
            itemNo: item.productNumber,
            itemQty: item.quantity,
          })),
        },
      ],
  
  };
};

/**
 * Payload for PUT requests
 * @param {Array} items { productNumber, productType, quantity }
 */
const putPayload = (items) =>  items.items.map((item) => ({
  itemType: item.productType.toUpperCase(),
  itemNo: item.productNumber,
  itemQty: item.quantity,
}));

const baseRequestObject = {
  headers: {
    Accept: "application/vnd.middleware-v1+json",
    Contract: CONFIG.iowsApiContract,
    Consumer: CONFIG.iowsApiConsumer,
    "Content-type": "application/json",
  },
  mode: "cors",
  cache: "default",
  credentials: "include",
};

const getRequestObject = {
  post: (state) =>
    Object.assign({}, baseRequestObject, {
      method: "POST",
      url: `${securemaBaseUrl}/${market}/customer/irw/${state.userId}/shoppingbags/onlineshoppingcart`,
      body: JSON.stringify(state.payload),
      "Content-type": "application/vnd.middleware-v1+json",
    }),
  put: (state) =>
    Object.assign({}, baseRequestObject, {
      method: "POST",
      url: `${securemaBaseUrl}/${market}/customer/irw/${state.userId}/shoppingbags/onlineshoppingcart/${state.bagId}/items`,
      body: JSON.stringify(state.payload),
      "Content-type": "application/vnd.middleware-v1+json",
    }),
  getBags: (state) =>
    Object.assign({}, baseRequestObject, {
      method: "GET",
      url: `${securemaBaseUrl}/${market}/customer/irw/${state.userId}/shoppingbags/onlineshoppingcart`,
    }),
  getBag: (state) =>
    Object.assign({}, baseRequestObject, {
      method: "GET",
      url: `${securemaBaseUrl}/${market}/customer/irw/${state.userId}/shoppingbags/onlineshoppingcart/${state.bagId}`,
    }),
};

export default purchase;
